import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { AuthService } from "@app/modules/shared/services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import "rxjs/operator/finally";
import { UtilService } from "@app/modules/shared/services/util.service";

@Component({
  selector: "kl-forgot-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  errorStatus = false;
  alertShow = false;
  successStatus = false;
  passwordStatus = false;
  selectedLanguage: string;
  alertMessage: string;
  token: any;
  user = {
    username: "",
  };
  reset = {
    password: "",
    confirm_password: "",
  };

  constructor(
    private _translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private utilService: UtilService,
    private klLoadingService: KlLoadingService,
    private alertService: KlSweetAlertService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (localStorage.getItem("currentLanguage")) {
      this.selectedLanguage = localStorage.getItem("currentLanguage");
    } else {
      this.selectedLanguage = "tr";
    }
    this.selectLang(this.selectedLanguage);
    this.token = this.activeRoute.snapshot.queryParams.token;
  }

  selectLang(lang: string) {
    this._translate.useCulture(lang);
    this._translate.use(lang);
  }

  onSubmit(action: string) {
    this.klLoadingService.show("loading");
    switch (action) {
      case "forgot":
        this.authService.forgotPassword(this.user).subscribe(
          (resForgot) => {
            this.successStatus = true;
            this.errorStatus = false;
            this.klLoadingService.hide();
          },
          (errForgot) => {
            this.klLoadingService.hide();
            this.successStatus = false;
            this.alertShow = true;
            this.alertMessage = this.utilService.alertErrorMessage(errForgot);
          }
        );
        break;
      case "reset":
        if (this.reset.password === this.reset.confirm_password) {
          const reset = {
            password: this.reset.password,
            token: this.token,
          };
          this.authService.resetPassword(reset).subscribe(
            (resReset) => {
              this.klLoadingService.hide();
              this.successStatus = true;
              this.errorStatus = false;
            },
            (errReset) => {
              this.klLoadingService.hide();
              this.successStatus = false;
              this.alertService.alertError({}, errReset);
            }
          );
        } else {
          this.passwordStatus = true;
        }
        break;
    }
  }
}
